class VariantOption extends HTMLElement {
  radioInput;
  button;

  constructor() {
    super();
    this.radioInput = this.querySelector('input[type=radio]');
    this.button = this.querySelector('button');

    this.outOfStockFormExists = !!document.querySelector('out-of-stock-form');

    if (this.outOfStockFormExists) {
      this.checkStatus();
    }

    this.button.addEventListener('click', (ev) => {
      if (this.outOfStockFormExists) {
        if (this.radioInput.classList.contains('disabled')) {
          document.querySelector('product-form')?.classList.add('hidden');
          document.querySelector('out-of-stock-form')?.classList.remove('hidden');
        } else {
          document.querySelector('product-form')?.classList.remove('hidden');
          document.querySelector('out-of-stock-form')?.classList.add('hidden');
        }
      }

      let bagButton = document.querySelector('product-form button');
      if (bagButton && this.radioInput.classList.contains('disabled')) {
        bagButton.setAttribute('disabled', true);
        bagButton.querySelector('[sold-out]')?.classList.remove('hidden');
        bagButton.querySelector('[add-to-cart]')?.classList.add('hidden');
      } else if (bagButton) {
        bagButton.removeAttribute('disabled');
        bagButton.querySelector('[sold-out]')?.classList.add('hidden');
        bagButton.querySelector('[add-to-cart]')?.classList.remove('hidden');
      }

      let variantId = this.radioInput.dataset.optionValueId;

      if (variantId) {
        document.querySelector('input[product-variant-id]').value = this.radioInput.dataset.optionValueId;
        let newUrl = `${window.location.origin}${window.location.pathname}?variant=${variantId}`;
        window.history.replaceState({}, '', newUrl);
      }
      this.radioInput.click();
    });
  }

  checkStatus() {
    if (this.radioInput.checked && this.radioInput.classList.contains('disabled')) {
      document.querySelector('product-form').classList.add('hidden');
      document.querySelector('out-of-stock-form').classList.remove('hidden');
    }
  }
}

customElements.define('variant-option', VariantOption);
